import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Layout } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { hexToHexA } from '../../utils/color';
import MainMenu from '../Menu/Main';
import { version } from '../../version.js';
import { TraceLogs } from '../Modals/TraceLogs.jsx';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectActiveUnseenCount, selectResolvedUnseenCount } from '../../modules/issues/stores/slice';
import { doGetUnseen } from '../../modules/issues/stores/thunk';
import { doResetImpersonation } from '../../modules/auth/stores/thunk';
import { ROLES } from '../../constants';

const { Header } = Layout;

const MainHeader = () => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const location = useLocation();

  //const [popoverIssuesVisible, setPopoverIssuesVisible] = useState(false);
  const backgroundOpacity = hexToHexA(user?.primaryColor || '#93BFFF', 0.24);
  const avatarBackground = backgroundOpacity?.replace('#', '');
  const avatarColor = user?.primaryColor?.replace('#', '');
  const activeUnseenCount = useSelector((state) => selectActiveUnseenCount(state));
  const resolvedUnseenCount = useSelector((state) => selectResolvedUnseenCount(state));
  const userRole = useSelector((state) => state.auth.user.role);

  const [showLogs, setShowLogs] = useState(false);

  const stopImpersonation = async () => {
    await dispatch(doResetImpersonation());
    window.location.reload();
  };

  const dropdowns = useMemo(() => {
    const isAccountAdmin = user.role === 'ADMIN';
    return [
      isAccountAdmin
        ? {
            label: (
              <Link to={`/users`}>
                <Button type="text" size="small">
                  Users
                </Button>
              </Link>
            ),
            key: '/users',
          }
        : null,
      user.role !== ROLES.CARRIER_USER
        ? {
            label: (
              <Link to={`/settings`}>
                <Button type="text" size="small">
                  Settings
                </Button>
              </Link>
            ),
            key: '/settings',
          }
        : null,
      user.isAdmin
        ? {
            label: (
              <div onClick={() => setShowLogs(true)}>
                <Button type="text" size="small">
                  Trace logs
                </Button>
              </div>
            ),
            key: '/trace',
          }
        : null,
      {
        label: (
          <Link to="/logout">
            <Button type="text" size="small">
              Log Out
            </Button>
          </Link>
        ),
        key: '/logout',
      },
      user.impersonatedBy
        ? {
            label: (
              <div onClick={() => stopImpersonation()}>
                <Button type="text" size="small">
                  Stop impersonating
                </Button>
              </div>
            ),
            key: '/impersonate/reset',
          }
        : null,
      {
        label: <div style={{ display: 'flex', justifyContent: 'end', cursor: 'default' }}>{version}</div>,
        key: '/version',
      },
    ].filter(Boolean);
  }, [user.isAdmin, user]);

  const fetchIssueCount = async () => {
    await dispatch(doGetUnseen());
  };

  useEffect(() => {
    fetchIssueCount(); // Fetch initial issues on every page load
  }, [location.pathname, activeUnseenCount, resolvedUnseenCount, userRole]);

  return (
    <>
      <Header className="MainHeader" style={{ position: 'fixed', zIndex: 999, width: '100%' }}>
        <div className="logo">
          <Link to="/home">{/* <img src={default_logo} alt="logo" /> */}</Link>
        </div>
        {user && (
          <>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
              <MainMenu user={user} activeUnseenCount={activeUnseenCount} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', zIndex: 9999 }}>
              {/* <Popover
                overlayClassName="share-content-order"
                placement="bottomRight"
                content={<OrderIssues setPopoverIssuesVisible={setPopoverIssuesVisible} />}
                trigger="click"
                open={popoverIssuesVisible}
                onOpenChange={(visible) => setPopoverIssuesVisible(visible)}
              >
                <div
                  onClick={() => setPopoverIssuesVisible(true)}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '4px',
                    marginRight: '10px',
                  }}
                >
                  <Badge
                    dot={activeIssues?.some((issue) => issue.hasSeen === false)}
                    style={
                      activeIssues?.some((issue) => issue.hasSeen === false)
                        ? { height: '8px', width: '8px' }
                        : { height: '8px', width: '8px', visibility: 'hidden' }
                    }
                  >
                    <ReactSVG className="icon" src="/icons/issues.svg" style={{ display: 'flex' }} />
                  </Badge>
                </div>
              </Popover> */}

              <Dropdown menu={{ items: dropdowns }}>
                <div className="account-info" style={{ backgroundColor: user?.impersonatedBy ? 'orange' : undefined }}>
                  <div className="avatar">
                    <img
                      src={`https://ui-avatars.com/api/?length=1&name=${
                        user?.name || user?.email
                      }&size=32&font-size=0.4&bold=true&background=${
                        avatarBackground || '9863f3'
                      }&color=${avatarColor}&rounded=true`}
                      alt=""
                    />
                  </div>

                  <div className="info">
                    <div className="fullname">{user?.impersonatedBy ? 'IMPERSONATING' : user?.name}</div>

                    <div className="email">
                      {user?.email} <DownOutlined />
                    </div>
                  </div>
                </div>
              </Dropdown>
            </div>
          </>
        )}
      </Header>
      {showLogs && <TraceLogs show={showLogs} close={() => setShowLogs(false)} />}
    </>
  );
};

export default MainHeader;
